import React from "react";
import {
  BrowserRouter as Router,
  Routes as Switch,
  Route,
  Navigate,
} from "react-router-dom";

import Locations from "./components/Locations";
import Menu from "./components/Menu";
import Contact from "./components/Contact";
import Nomatch from "./components/Nomatch";

export default function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" element={<Locations />} />
        <Route
          path="/location/:locationId/:templateId/menu"
          element={<Menu />}
        />
        <Route
          path="/location/:locationId/:templateId/contact"
          element={<Contact />}
        />
        <Route path="/menu/" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Nomatch />} />
      </Switch>
    </Router>
  );
}
